import { Box, Col, Container, Row, Text, Title } from '@qonsoll/react-design'

import { Button } from '@qonsoll/react-design'
import PATHS from 'pages/paths'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { useTranslations } from 'contexts/Translation'

const NewsTipCreatedSimpleView = (props) => {
  const { timeToClose = 8000, isGuestMode = false } = props
  const { AUTHENTICATED, UNAUTHENTICATED } = PATHS

  const { t } = useTranslations()
  const history = useHistory()

  const navigateAfterWizardClose = () => {
    const pathComputed = isGuestMode
      ? UNAUTHENTICATED.NEWS_TIP_WIZARD
      : AUTHENTICATED.DASHBOARD

    return history.push(pathComputed)
  }
  const handlePrimaryActionButtonClick = () => {
    timer && clearTimeout(timer) // clearing the timer

    /* going back to the main page (tip creation wizard)
			after successful tip submission */
    navigateAfterWizardClose()
  }

  const timer = setTimeout(navigateAfterWizardClose, timeToClose)
  const primaryActionButtonTextComputed = t(
    isGuestMode ? 'Back to main page' : 'Go to your page'
  )

  return (
    <Container
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%">
      <Row>
        <Col cw={12}>
          <Box
            height="100%"
            display="flex"
            flexDirection="column"
            alignItems={['stretch', 'center']}
            justifyContent={['stretch', 'center']}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              mb={[4, 64]}>
              <Title variant={['h3', 'h1']} textAlign="center" mb={[2, 3]}>
                {`${t('Thanks for the tip')}!`}
              </Title>
              <Text textAlign="center" mb={[3, '20px']}>
                {`${t('You can check your points balance on your profile')}. `}
                {`${t(
                  'You will receive an email when your tip has been reviewed'
                )}.`}
              </Text>
              <Box>
                <Button
                  type="primary"
                  size="medium"
                  block
                  onClick={handlePrimaryActionButtonClick}>
                  {primaryActionButtonTextComputed}
                </Button>
              </Box>
            </Box>
          </Box>
        </Col>
      </Row>
    </Container>
  )
}

NewsTipCreatedSimpleView.propTypes = {
  timeToClose: PropTypes.number,
  isGuestMode: PropTypes.bool
}

export default NewsTipCreatedSimpleView
